@if (rendered()) {
  <div class="flex flex-col gap-12"
       data-test="objects-list"
  >
    @if (aircraftSchedules().length > 0) {
      <div class="grid gap-2"
           data-test="albert-fleet-list-table"
      >
        <h1 class="font-bold text-l">Fleet List</h1>
        @if (isMobile()) {
          <div class="flex flex-col gap-4"
               data-test="albert-fleet-list-cards"
          >
            @for (group of aircraftGroups(); track group.shared.uuid) {
              <p-card data-test="albert-fleet-list-card">
                <ng-template #header>
                  <div class="flex items-center gap-2 p-4 pb-0">
                    <p-tag rounded="true"
                           [severity]="getStatusSeverity(group.shared.objectStatus)"
                           [value]=""
                    />
                    <h2 class="font-bold text-base m-0">{{ group.shared.aircraftType }}</h2>
                  </div>
                </ng-template>
                <div class="flex flex-col gap-1 pl-5">
                  <div class="flex justify-between gap-4 pt-2 pb-2 border-b border-gray-200">
                    <span class="font-medium">Registration</span>
                    <span>{{ group.shared.registration }}</span>
                  </div>
                  <div class="flex justify-between gap-4 pt-2 pb-2 border-b border-gray-200">
                    <span class="font-medium">MSN</span>
                    <a class="underline"
                       target="_blank"
                       [href]="aircraftScheduleUrl(group.shared.externalId)"
                    >{{ group.shared.serialNumber }}
                    </a>
                  </div>
                  <div class="flex justify-between gap-4 pt-2 pb-2 border-b border-gray-200">
                    <span class="font-medium">MTOW</span>
                    <span>{{ group.shared.mtow }}</span>
                  </div>
                  @for (variant of group.variants; track variant.uuid; let i = $index) {
                    <ng-container *ngTemplateOutlet="rowItem; context: {
                      index: i,
                      total: group.variants.length,
                      singularLabel: 'Lease Value',
                      pluralLabel: 'Lease Values',
                      value: variant.leaseValue,
                      currency: variant.leaseValueCurrency,
                      showPeriod: true,
                      begin: variant.beginOfValueDetail,
                      end: variant.endOfValueDetail
                    }"
                    />
                  }

                  @for (variant of group.variants; track variant.uuid; let i = $index) {
                    <ng-container *ngTemplateOutlet="rowItem; context: {
                      index: i,
                      total: group.variants.length,
                      singularLabel: 'TPLL War Excess Limit',
                      pluralLabel: 'TPLL War Excess Limits',
                      value: variant.tpllWarExcessLimit,
                      currency: variant.tpllWarExcessLimitCurrency
                    }"
                    />
                  }
                </div>
              </p-card>
            }
          </div>
        } @else {
          <div class="w-full overflow-x-auto">
            <p-table data-test="albert-fleet-list-table"
                     scrollHeight="693px"
                     scrollable="true"
                     [lazy]="true"
                     [sortField]="aircraftSort().field"
                     [sortOrder]="aircraftSort().order"
                     [value]="aircraftSchedules()"
                     (onLazyLoad)="onAircraftSort($event)"
            >
              <ng-template #header>
                <tr>
                  <th id="fleet-status"
                      pSortableColumn="objectStatus"
                  >Status
                    <p-sort-icon field="objectStatus"/>
                  </th>
                  <th id="fleet-aircraft-type"
                      pSortableColumn="aircraftType"
                  >Aircraft Type
                    <p-sort-icon field="aircraftType"/>
                  </th>
                  <th id="fleet-registration"
                      pSortableColumn="registration"
                  >Registration
                    <p-sort-icon field="registration"/>
                  </th>
                  <th id="fleet-msn"
                      pSortableColumn="serialNumber"
                  >MSN
                    <p-sort-icon field="serialNumber"/>
                  </th>
                  <th class="align-right"
                      id="fleet-mtow"
                      pSortableColumn="mtow"
                  >MTOW
                    <p-sort-icon field="mtow"/>
                  </th>
                  <th class="align-right"
                      id="fleet-lease-value"
                      pSortableColumn="leaseValue"
                  >Lease Value
                    <p-sort-icon field="leaseValue"/>
                  </th>
                  <th class="align-right"
                      id="fleet-lease-value-begin"
                      pSortableColumn="beginOfValueDetail"
                  >Begin of Lease Value
                    <p-sort-icon field="beginOfValueDetail"/>
                  </th>
                  <th class="align-right"
                      id="fleet-lease-value-end"
                      pSortableColumn="endOfValueDetail"
                  >End of Lease Value
                    <p-sort-icon field="endOfValueDetail"/>
                  </th>
                  <th class="align-right"
                      id="fleet-tpll-war-excess-limit"
                      pSortableColumn="tpllWarExcessLimit"
                  >TPLL War Excess Limit
                    <p-sort-icon field="tpllWarExcessLimit"/>
                  </th>
                </tr>
              </ng-template>
              <ng-template #body
                           let-aircraftSchedule
              >
                <tr [class.schedule-group-striped]="aircraftSchedule.striped">
                  <td>
                    <p-tag rounded="true"
                           [severity]="getStatusSeverity(aircraftSchedule.objectStatus)"
                           [value]=""
                    />
                  </td>
                  <td>{{ aircraftSchedule.aircraftType }}</td>
                  <td>{{ aircraftSchedule.registration }}</td>
                  <td>
                    <a class="underline"
                       target="_blank"
                       [href]="aircraftScheduleUrl(aircraftSchedule.externalId)"
                    >{{ aircraftSchedule.serialNumber }}
                    </a>
                  </td>
                  <td class="align-right">{{ aircraftSchedule.mtow }}</td>
                  <td class="align-right">{{ aircraftSchedule.leaseValue | formatCurrencyAmount: aircraftSchedule.leaseValueCurrency }}</td>
                  <td class="align-right"
                      data-test="fleet-lease-value-begin"
                  >{{ (aircraftSchedule.beginOfValueDetail | date: 'dd.MM.yyyy' : 'UTC') ?? '-' }}</td>
                  <td class="align-right"
                      data-test="fleet-lease-value-end"
                  >{{ (aircraftSchedule.endOfValueDetail | date: 'dd.MM.yyyy' : 'UTC') ?? '-' }}</td>
                  <td class="align-right">{{ aircraftSchedule.tpllWarExcessLimit | formatCurrencyAmount: aircraftSchedule.tpllWarExcessLimitCurrency }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    }
    @if (equipmentSchedules().length > 0) {
      <div data-test="albert-equipment-list-table">
        <h1 class="font-bold text-l">Equipment List</h1>
        @if (isMobile()) {
          <div class="flex flex-col gap-4"
               data-test="albert-equipment-list-cards"
          >
            @for (group of equipmentGroups(); track group.shared.uuid) {
              <p-card data-test="albert-equipment-list-card">
                <ng-template #header>
                  <div class="flex items-center gap-2 p-4 pb-0">
                    <p-tag rounded="true"
                           [severity]="getStatusSeverity(group.shared.objectStatus)"
                           [value]=""
                    />
                    <h2 class="font-bold text-base m-0">{{ group.shared.equipmentType }}</h2>
                  </div>
                </ng-template>
                <div class="flex flex-col gap-1 pl-5">
                  <div class="flex justify-between gap-4 pt-2 pb-2 border-b border-gray-200">
                    <span class="font-medium">Equipment Category</span>
                    <span>{{ group.shared.equipmentCategory }}</span>
                  </div>
                  <div class="flex justify-between gap-4 pt-2 pb-2 border-b border-gray-200">
                    <span class="font-medium">SN</span>
                    <a class="underline"
                       target="_blank"
                       [href]="equipmentScheduleUrl(group.shared.externalId)"
                    >{{ group.shared.serialNumber }}
                    </a>
                  </div>
                  @for (variant of group.variants; track variant.uuid; let i = $index) {
                    <ng-container *ngTemplateOutlet="rowItem; context: {
                      index: i,
                      total: group.variants.length,
                      singularLabel: 'Lease Value',
                      pluralLabel: 'Lease Values',
                      value: variant.leaseValue,
                      currency: variant.leaseValueCurrency,
                      showPeriod: true,
                      begin: variant.activeDate,
                      end: variant.inactiveDate
                    }"
                    />
                  }
                </div>
              </p-card>
            }
          </div>
        } @else {
          <div class="w-full overflow-x-auto">
            <p-table data-test="albert-equipment-list-table"
                     scrollHeight="693px"
                     scrollable="true"
                     [lazy]="true"
                     [sortField]="equipmentSort().field"
                     [sortOrder]="equipmentSort().order"
                     [value]="equipmentSchedules()"
                     (onLazyLoad)="onEquipmentSort($event)"
            >
              <ng-template #header>
                <tr>
                  <th id="equipment-status"
                      pSortableColumn="objectStatus"
                  >Status
                    <p-sort-icon field="objectStatus"/>
                  </th>
                  <th id="equipment-category"
                      pSortableColumn="equipmentCategory"
                  >Equipment Category
                    <p-sort-icon field="equipmentCategory"/>
                  </th>
                  <th id="equipment-type"
                      pSortableColumn="equipmentType"
                  >Equipment Type
                    <p-sort-icon field="equipmentType"/>
                  </th>
                  <th id="equipment-sn"
                      pSortableColumn="serialNumber"
                  >SN
                    <p-sort-icon field="serialNumber"/>
                  </th>
                  <th class="align-right"
                      id="equipment-lease-value"
                      pSortableColumn="leaseValue"
                  >Lease Value
                    <p-sort-icon field="leaseValue"/>
                  </th>
                  <th class="align-right"
                      id="equipment-lease-value-begin"
                      pSortableColumn="activeDate"
                  >Begin of Lease Value
                    <p-sort-icon field="activeDate"/>
                  </th>
                  <th class="align-right"
                      id="equipment-lease-value-end"
                      pSortableColumn="inactiveDate"
                  >End of Lease Value
                    <p-sort-icon field="inactiveDate"/>
                  </th>
                </tr>
              </ng-template>
              <ng-template #body
                           let-equipmentSchedule
              >
                <tr [class.schedule-group-striped]="equipmentSchedule.striped">
                  <td>
                    <p-tag rounded="true"
                           [severity]="getStatusSeverity(equipmentSchedule.objectStatus)"
                           [value]=""
                    />
                  </td>
                  <td>{{ equipmentSchedule.equipmentCategory }}</td>
                  <td>{{ equipmentSchedule.equipmentType }}</td>
                  <td>
                    <a class="underline"
                       target="_blank"
                       [href]="equipmentScheduleUrl(equipmentSchedule.externalId)"
                    >{{ equipmentSchedule.serialNumber }}
                    </a>
                  </td>
                  <td class="align-right">{{ equipmentSchedule.leaseValue | formatCurrencyAmount: equipmentSchedule.leaseValueCurrency }}</td>
                  <td class="align-right"
                      data-test="equipment-lease-value-begin"
                  >{{ (equipmentSchedule.activeDate | date: 'dd.MM.yyyy' : 'UTC') ?? '-' }}</td>
                  <td class="align-right"
                      data-test="equipment-lease-value-end"
                  >{{ (equipmentSchedule.inactiveDate | date: 'dd.MM.yyyy' : 'UTC') ?? '-' }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    }
    @if (aircraftSchedules().length === 0 && equipmentSchedules().length === 0) {
      <h1 class="font-bold text-l">No Assets linked to this Insured!</h1>
    }
  </div>
}

<ng-template #rowItem
             let-begin="begin"
             let-curr="currency"
             let-end="end"
             let-i="index"
             let-plural="pluralLabel"
             let-showPeriod="showPeriod"
             let-singular="singularLabel"
             let-total="total"
             let-val="value"
>

  @let isMulti = total > 1;
  @let labelText = !isMulti ? singular : (i === 0 ? plural : '');

  <div class="flex flex-col gap-1 pt-2 pb-2 border-b border-gray-200">
    <div class="flex justify-between items-center w-full gap-4">

      <span [attr.aria-hidden]="labelText ? null : true"
            [class.font-medium]="labelText"
      >
        {{ labelText }}
      </span>

      <span class="text-right">{{ val | formatCurrencyAmount: curr }} </span>
    </div>

    @if (showPeriod) {
      <div class="flex justify-between w-full gap-4 text-sm text-gray-600"
           data-test="lease-value-begin"
      >
        <span>Begin of Lease Value</span>
        <span class="text-right">{{ (begin | date: 'dd.MM.yyyy' : 'UTC') ?? '-' }}</span>
      </div>
      <div class="flex justify-between w-full gap-4 text-sm text-gray-600"
           data-test="lease-value-end"
      >
        <span>End of Lease Value</span>
        <span class="text-right">{{ (end | date: 'dd.MM.yyyy' : 'UTC') ?? '-' }}</span>
      </div>
    }
  </div>
</ng-template>
